import React from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';

export class MediaTagsDisplay extends BaseEntityPage {

  constructor(props, options) {
    super(props, options)
    this.pageKey = 'MediaTagsDisplay'
    this.pageTitle = Helper.getString('mediaTags')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.groupId = 'assettag' + this.orgId
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['items'], queryParams: { groupId: this.groupId, pb: 'fieldDef' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
      Type: (current) => {
        return (
          <div>
            {UiHelper.chipLive(current.state)}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.groupId
    }
    this.addNewLabel = 'Create Media Tag'
    this.noTableHead = true
    this.allowAccessToRoles = ['VENUES']
    if (!UiHelper.isUserHasRoles(this.allowAccessToRoles)) this.noAdd = true
  }

  onFetchSuccess(results) {
    this.formDefinition = this.fieldDef = results[0].fieldDef
    this.setState({
      items: results[0].items
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['items'], { groupId: this.groupId }),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['items', current.id], { groupId: this.groupId }),
    });
  }

  onActions(current) {
    const actions = []
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonEdit(this, current), this.allowAccessToRoles)
    UiHelper.addActionButtonByRole(actions, UiHelper.buttonDelete(this, current), this.allowAccessToRoles)
    return actions
  }
}



// WEBPACK FOOTER //
// ./src/screens/admin/MediaTagsDisplay.js